import type UpsellingAlternative from './UpsellingAlternative';
import { StatusCodes } from 'http-status-codes';

export const getAlternative = async (variationId: string): Promise<UpsellingAlternative | undefined> => {
  try {
    const response = await fetch(`/upselling/${variationId}`, {
      method: 'GET',
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
    });

    if (response.status === StatusCodes.OK) {
      return await response.json() as UpsellingAlternative;
    }

    return undefined;
  }
  catch (exception) {
    return undefined;
  }
};
